export default __webpack_public_path__ + "c4753103354e176f7b411683a4eca33c.png";